import { Link } from 'react-router-dom';
import { Button, Tooltip, Badge, Space } from 'antd';
import { PrakurtiCirculerLogo } from '../../../components/imagepath';
import FeatherIcon from 'feather-icons-react';
import moment from 'moment';
import { formatTime } from '../../../utils/helpers/dateHelpers';
export const getColumns = (params, canUpdate, onNotesClick) => [
    {
        name: '#',
        id: 'sr',
        width: '60px',
        cell: (row, index) => {
            const currentPage = parseInt(params?.page) || 1;
            const perPage = parseInt(params?.perPage) || 10;
            const calculatedIndex = (currentPage - 1) * perPage + index + 1;
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ color: '#8c8c8c', fontWeight: 500 }}>{calculatedIndex}</span>
                    {row?.isSimulation && (
                        <Tooltip title="Simulation Mode">
                            <img
                                src={PrakurtiCirculerLogo}
                                alt="sim"
                                style={{ width: '16px', height: '16px', borderRadius: '50%' }}
                            />
                        </Tooltip>
                    )}
                </div>
            );
        },
    },
    {
        name: 'Patient',
        id: 'customerName',
        selector: row => row.customerName,
        sortable: true,
        minWidth: '200px',
        cell: row => (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Tooltip title={`Full Name: ${row.customerName}`} placement="topLeft">
                    <Link
                        to={`/patient-list/patient-profile/${row?.customerId?._id || row?.customerId}?page=${params?.page}`}
                        style={{ fontWeight: 600, color: '#1890ff', display: 'block', maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {row.customerName}
                    </Link>
                </Tooltip>
                <div style={{ fontSize: '11px', lineHeight: '1.4', color: '#8c8c8c' }}>
                    {row.customerId?.phoneNo ? `+${row.customerId?.countryCode} ${row.customerId?.phoneNo}` : row?.phoneNo}
                    <br />
                    {/* {row.registrationNo || '—'} */}
                </div>
            </div>
        ),
    },
    {
        name: 'Doctor',
        id: 'doctorName',
        selector: row => row.doctorName || '—',
        sortable: true,
        width: '180px',
        cell: row => (
            <span style={{ fontWeight: 500, color: '#434343' }}>
                {row.doctorName || '—'}
            </span>
        ),
    },
    {
        name: 'Condition & Purpose',
        id: 'condition',
        selector: row => `${row.treatment || 'General'} (${row.consultingFor})`,
        minWidth: '180px',
        cell: row => (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Tooltip title={`Condition: ${row.treatment}`}>
                    <span style={{ fontSize: '13px', fontWeight: 500, color: '#1890ff', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {row.treatment || 'General'}
                    </span>
                </Tooltip>
                <Tooltip title={`Visit: ${row.consultingFor}`}>
                    <span style={{ fontSize: '11px', color: '#fa8c16', maxWidth: '160px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {row.consultingFor}
                    </span>
                </Tooltip>
            </div>
        ),
    },
    {
        name: 'Schedule',
        id: 'schedule',
        selector: row => `${moment(row.date, ["DD-MM-YYYY", "YYYY-MM-DD"]).format('DD-MM-YYYY')} ${row.startTime} - ${row.endTime}`,
        sortable: true,
        width: '180px',
        cell: row => {
            const calculateDuration = () => {
                const formats = ['h.mm a', 'h:mm a', 'HH:mm', 'H.mm', 'h.mm', 'h:mm', 'hh:mm A'];
                const start = moment(row.startTime, formats);
                const end = moment(row.endTime, formats);
                if (!start.isValid() || !end.isValid()) return null;

                const diff = end.diff(start);
                const duration = moment.duration(diff);
                const h = Math.floor(duration.asHours());
                const m = duration.minutes();

                if (h > 0) return `${h}h${m > 0 ? ` ${m}m` : ''}`;
                return `${m} min`;
            };

            const duration = calculateDuration();

            return (
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <span style={{ fontWeight: 500 }}>
                        {moment(row.date, ["DD-MM-YYYY", "YYYY-MM-DD"]).format('DD-MM-YYYY')}
                    </span>
                    <div style={{ fontSize: '12px', color: '#8c8c8c', display: 'flex', flexDirection: 'column', gap: '2px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ color: '#595959' }}>{`${formatTime(row.startTime)} - ${formatTime(row.endTime)}`}</span>
                            {duration && (
                                <span style={{
                                    fontSize: '10px',
                                    background: '#f5f5f5',
                                    padding: '0 4px',
                                    borderRadius: '4px',
                                    color: '#8c8c8c',
                                    fontWeight: 500,
                                    border: '1px solid #e8e8e8'
                                }}>
                                    {duration}
                                </span>
                            )}
                        </div>
                        <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            <span style={{ color: '#52c41a', fontSize: '10px', fontWeight: 600, textTransform: 'uppercase' }}>{row.consultationType}</span>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        name: 'Status',
        id: 'status',
        sortable: true,
        width: '130px',
        cell: row => {
            const statusColors = {
                Upcoming: 'processing',
                Completed: 'success',
                Cancelled: 'error',
            };

            const paymentStatus = row.orderId?.paymentStatus || 'Pending';

            // Comprehensive Payment Status Colors
            const getPaymentStyle = (status) => {
                switch (status?.toLowerCase()) {
                    case 'paid':
                    case 'completed':
                        return { bg: '#f6ffed', text: '#52c41a', border: '#b7eb8f' };
                    case 'partially paid':
                        return { bg: '#e6f7ff', text: '#1890ff', border: '#91d5ff' };
                    case 'pending':
                    case 'awaiting':
                        return { bg: '#fff7e6', text: '#fa8c16', border: '#ffd591' };
                    default:
                        return { bg: '#fff1f0', text: '#f5222d', border: '#ffa39e' };
                }
            };

            const pStyle = getPaymentStyle(paymentStatus);

            return (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <Badge
                        status={statusColors[row.status] || 'default'}
                        text={<span style={{ fontWeight: 500, fontSize: '13px' }}>{row.status}</span>}
                    />
                    <Tooltip title={`Payment Status: ${paymentStatus}`}>
                        <div style={{
                            fontSize: '10px',
                            padding: '0 8px',
                            borderRadius: '10px',
                            background: pStyle.bg,
                            color: pStyle.text,
                            border: `1px solid ${pStyle.border}`,
                            width: 'fit-content',
                            marginLeft: '12px',
                            fontWeight: 600,
                            textTransform: 'uppercase',
                            cursor: 'help',
                            whiteSpace: 'nowrap'
                        }}>
                            {paymentStatus}
                        </div>
                    </Tooltip>
                </div>
            );
        },
    },
    {
        name: 'Actions',
        id: 'actions',
        width: '160px',
        omit: !canUpdate,
        cell: row => {
            const isCompleted = row.status === 'Completed';
            const isCancelled = row.status === 'Cancelled';
            const actionText = isCancelled ? 'View' : isCompleted ? 'Summary' : 'Consult';

            return (
                <Space size="small">
                    <Button
                        type={isCompleted || isCancelled ? "default" : "primary"}
                        size="small"
                        onClick={() => {
                            const userId = row?.customerId?._id || row?.customerId || row?._id;
                            window.location.href = `/patient-list/appointment-details?page=${params?.page || 1}&appointmentId=${row?._id}&userId=${userId}&consultingFor=${row?.consultingFor}`;
                        }}
                        style={{ fontSize: '12px', minWidth: '75px' }}
                    >
                        {actionText}
                    </Button>
                    <Tooltip title={row?.notes ? 'View Notes' : 'Add Notes'}>
                        <Button
                            size="small"
                            type="text"
                            icon={<FeatherIcon icon={row?.notes ? "file-text" : "edit-3"} size={16} />}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onNotesClick(row);
                            }}
                            style={{ color: row?.notes ? '#1890ff' : '#bfbfbf' }}
                        />
                    </Tooltip>
                </Space>
            );
        },
    },
];

